import ProductMediaGallery from './ProductMediaGallery';

// Initialize gallery and store instance on the element
const initializeGallery = (gallery, options = {}) => {
    if (!gallery) return;

    // Safety: Destroy old instance if it exists
    const existingInstance = gallery.productMediaGalleryInstance;
    if (existingInstance) {
        existingInstance.destroy();
    }

    // Create and store new instance
    const currentSlide = gallery.getAttribute('data-current-slide') || 0;
    const galleryOptions = {
        currentSlide: currentSlide,
        ...options
    };

    gallery.productMediaGalleryInstance = new ProductMediaGallery(gallery, galleryOptions);
};

// Clean up gallery instance
const destroyGallery = (gallery) => {
    if (!gallery) return;

    const instance = gallery.productMediaGalleryInstance;
    if (!instance) return;

    instance.destroy();
    delete gallery.productMediaGalleryInstance;
};

document.addEventListener('DOMContentLoaded', () => {
    // Initialize all galleries on page load, except modal galleries
    const galleries = document.querySelectorAll('.product-media-gallery:not([data-init="modal"])');
    galleries.forEach(gallery => initializeGallery(gallery));

    // Only create modal listeners if modal galleries exist
    const hasModalGalleries = document.querySelector('.product-media-gallery[data-init="modal"]');
    if (hasModalGalleries) {
        document.addEventListener('modalOpened', (e) => {
            const modal = document.getElementById(e.detail.modalId);
            if (!modal) return;

            const gallery = modal.querySelector('.product-media-gallery[data-init="modal"]');
            initializeGallery(gallery);
        });

        document.addEventListener('modalClosed', (e) => {
            const modal = document.getElementById(e.detail.modalId);
            if (!modal) return;

            const gallery = modal.querySelector('.product-media-gallery[data-init="modal"]');
            destroyGallery(gallery);
        });
    }
});
